import { render, staticRenderFns } from "./brandenburgmap.vue?vue&type=template&id=e992d94a&"
import script from "./brandenburgmap.vue?vue&type=script&lang=js&"
export * from "./brandenburgmap.vue?vue&type=script&lang=js&"
import style0 from "./brandenburgmap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports